import React from 'react';

const ProductPricingTable = ({ name, price }) => {
  return (
    <div className='inventory-table'>
      <div className='properties'>
        <div className='brand-logo'>
          {/* <img
            className="brand-logo-img"
            src={props.logo || '/sample/H.png'}
            alt="logo"
          /> */}
        </div>
        <div className='brand-details brand-name'>
          {name}
          {/*<div className={'rate'}>*/}
          {/*    {props.rate}*/}
          {/*</div>*/}
        </div>
      </div>
      <div className='qty brand-qty'>₹{price}</div>
    </div>
  );
};

export default ProductPricingTable;
